import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DateTimeService } from 'app/core/services/date-time.service';
import { PrivateService } from 'app/core/services/private.service';
import { PayrollDefinition } from 'app/shared/models/payrollDef';
import { Time } from 'app/shared/models/time';
import { TimeEntries } from 'app/shared/models/timeEntries';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent implements OnInit, OnDestroy {

  updateApiTimeSheet: any;
  isLoading: boolean = false;

  constructor(public dialogRef: MatDialogRef<DialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private privateService: PrivateService,
    private dateTimeService: DateTimeService) { }
  type: any;
  time: Time;
  payrollDefinition: PayrollDefinition = null;
  flexiTimeEntries: TimeEntries[] = [];

  ngOnInit(): void {
    this.dateTimeService.time$.subscribe((updatedTime) => {
      this.time = updatedTime;
    });

    const payrollDefinition = localStorage.getItem('payrollDefinition');
    if (payrollDefinition) {
      this.payrollDefinition = JSON.parse(payrollDefinition);
    }

    this.updateTimeSheet();
  }

  ngOnDestroy(): void {
    clearTimeout(this.updateApiTimeSheet);
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
  getTimeSheet(): Observable<any> {
    return this.privateService.getTimeSheet();
  }
  async updateTimeSheet() {
    try {
      const data = await this.getTimeSheet().toPromise();
      localStorage.setItem('isTimeSheet', JSON.stringify(data));

      this.updateApiTimeSheet = setTimeout(() => this.updateTimeSheet(), 1000);
    } catch (error) {
      console.error('Error fetching time sheet', error);
    }
  }
  getTimeEntries(): Observable<TimeEntries> {
    return this.privateService.getTimeEntries();
  }
  async updateTimeEntries() {
    try {
      const data: TimeEntries = await this.getTimeEntries().toPromise();
      localStorage.setItem('TimeEntries', JSON.stringify(data));
    } catch (error) {
      console.warn('Error fetching time type:', error);
    }
  }
  getFlexiTimeEntries(): Observable<TimeEntries[]> {
    return this.privateService.getFlexiTimeEntries();
  }
  async updateFlexiTimeEntries() {
    try {
      const data: TimeEntries[] = await this.getFlexiTimeEntries().toPromise();
      this.flexiTimeEntries = data;
      localStorage.setItem('FlexiTimeEntries', JSON.stringify(this.flexiTimeEntries));
    } catch (error) {
      console.warn('Error fetching time type:', error);
    }
  }
  updateTimeSheet2() {
    this.privateService.getTimeSheet().subscribe(response => {
      localStorage.setItem('isTimeSheet', JSON.stringify(response));
      this.updateTimeEntries();
      clearTimeout(this.updateApiTimeSheet);
      this.dialogRef.close();
      this.isLoading = false;
    });
  }
  updateTimeSheetFlexi() {
    this.privateService.getTimeSheet().subscribe(response => {
      localStorage.setItem('isTimeSheet', JSON.stringify(response));
      this.updateFlexiTimeEntries();
      clearTimeout(this.updateApiTimeSheet);
      this.dialogRef.close();
      this.isLoading = false;
    });
  }
  submitTimeSheet(id: string) {
    this.isLoading = true;
    if (id != null) {
      this.privateService.submitTimeSheet(id).subscribe((response) => {
        this.updateTimeSheet2();
      }, (error) => {
        console.log(error);
        this.dialogRef.close();
        this.isLoading = false;
      })
    } else {
      this.privateService.submitFlexiTimeSheet().subscribe((response) => {
        this.updateTimeSheetFlexi();
      }, (error) => {
        console.log(error);
        this.dialogRef.close();
        this.isLoading = false;
      })
    }
  }
}